export const MOCK_SCOPES = [
  {
    key: 'user_management',
    heading: 'User Management',
    scopes: [
      {
        name: 'users:read',
        description: 'Read user profile and data'
      },
      {
        name: 'groups:read',
        description: 'Update user groups and data'
      },
      {
        name: 'organizations:read',
        description: 'Read organization profile and data'
      },
      {
        name: 'organizations:write',
        description: 'Update organization profile and data'
      }
    ]
  },
  {
    key: 'communications',
    heading: 'Communications',
    scopes: [
      {
        name: 'meeting_recaps:read',
        description: 'Read meeting recaps'
      },
      {
        name: 'routing_forms:read',
        description: 'Read routing forms'
      },
      {
        name: 'shares:write',
        description: 'Create and update shares for your own events only (not your customers\' events) only for your own events only'
      }
    ]
  },
  {
    key: 'scheduling',
    heading: 'Scheduling',
    scopes: [
      {
        name: 'scheduled_events:read',
        description: 'Read scheduling availability'
      },
      {
        name: 'scheduled_events:write',
        description: 'Create and update scheduled events'
      },
      {
        name: 'event_types:read',
        description: 'Read event types'
      },
      {
        name: 'event_types:write',
        description: 'Create and update event types'
      }
    ]
  }
]
